import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function updatePercentageRate(rowToEdit){
    try{
        const percentageRow = Number(rowToEdit.percentage_value.replace(',','.'))
        return await axios.put(`${REACT_APP_API}/abms/percentageRates/${rowToEdit.id}`, { percentage: percentageRow})
    }catch(error){
        throw new Error(error)
    }
}